import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { InterestCalculatorTable } from '../shared';
import { InterestCalculatorStyle } from './styles';
import { Line } from '../styles';
import { RebuttalHeader } from '../shared';

export const InterestCalculator = () => {
    const { t } = useTranslation();
    const { data, mobile } = useSlideData();
    const { details } = data;
    const { totalDebt, 
            currentMonthlyPayment, 
            avgInterestRate, 
            interestPerDay,
            totalMonthlyInterest, 
            totalAnnualInterest, 
            percentPaidInInterest } = details;
    
    const leftTableValues = [
        {
            label: 'monthly_payment',
            value: currentMonthlyPayment
        },
        {
            label: 'avg_interest_rate',
            value: avgInterestRate
        },
        {
            label: 'interest_per_day',
            value: interestPerDay
        }
    ];

    const rightTableValues = [
        {
            label: 'total_monthly_interest',
            value: totalMonthlyInterest
        },
        {
            label: 'total_annual_interest',
            value: totalAnnualInterest
        },
        {
            label: 'percent_paid_interest',
            value: percentPaidInInterest
        }
    ];

    return (
        <InterestCalculatorStyle mobile={mobile}>
            <RebuttalHeader
                balance={totalDebt}
                description={t('interest_calculator.total_debt')}/>
            <Line />
            <div>
                <InterestCalculatorTable
                    isRebuttal={true}
                    values={leftTableValues} />
                <InterestCalculatorTable
                    isRebuttal={true}
                    values={rightTableValues} />
            </div>
            <div>{t('interest_calculator.summary')}</div>
        </InterestCalculatorStyle>
    );
};

export default InterestCalculator;
